<template>
  <div class="">
    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">ApkVersions</h1>
        </div>
        <div class="md-toolbar-section-end">
          <md-button class="md-primary md-raised" @click="pushCreate">
            Criar versão
          </md-button>
          <md-field style="width: 50%">
            <md-input v-model="search" placeholder="Buscar app" />
          </md-field>
          <md-button class="md-primary md-raised" @click="searchApks">
            Buscar
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>App</md-table-head>
        <md-table-head>Versão</md-table-head>
        <md-table-head>Criado em</md-table-head>
        <md-table-head>Ação</md-table-head>
      </md-table-row>
      <md-table-row
        v-for="version in versions.results"
        :key="version.id"
        class="pt-2 pb-2"
      >
        <md-table-cell>{{ version.appName }}</md-table-cell>
        <md-table-cell>{{ version.version }}</md-table-cell>
        <md-table-cell>
          {{
            new Date(version.createdAt)
              .utcToLocalDate()
              .toLocaleDateString('pt-BR')
          }}
        </md-table-cell>
        <md-table-cell>
          <md-button
            class="md-raised md-primary"
            @click="() => baixarApk(version)"
          >
            Baixar APK
          </md-button>
          <md-button
            class="md-raised md-accent"
            @click="() => (deleteId = version.id)"
          >
            Deletar
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm
      :md-backdrop="true"
      :md-active="showDialogDelete"
      md-title="Tem certeza?"
      md-content="Deseja realmente deletar este app?"
      md-confirm-text="remover"
      md-cancel-text="cancelar"
      @md-confirm="() => removeAcao(deleteId)"
    />

    <md-dialog :md-active.sync="showDownload">
      <md-dialog-title>Download APK</md-dialog-title>

      <md-tabs md-dynamic-height>
        <md-tab md-label="General">
          <div v-if="showDownload" class="text-center">
            <h1>{{ progressDownload.percentComplete }} %</h1>
            <h2>{{ progressDownload.duration }} Duração</h2>
          </div>
        </md-tab>
      </md-tabs>
    </md-dialog>
  </div>
</template>

<script>
import fileDownload from 'js-file-download'

import http from '../../utils/http'

export default {
  name: 'ApkVersionIndex',
  data() {
    return {
      versions: [],
      search: '',
      openCreate: false,
      deleteId: null,
      progressDownload: null,
    }
  },
  computed: {
    showDialogDelete() {
      return this.deleteId !== null
    },
    showDownload() {
      return this.progressDownload !== null
    },
  },
  async beforeMount() {
    await this.searchApks()
  },
  methods: {
    async searchApks() {
      const response = await http.get('app-version', { name: this.search })

      this.versions = response.versions
    },
    async removeAcao(id) {
      await http.delete('app-version', id)

      await this.searchApks()

      this.deleteId = null
    },
    pushCreate() {
      this.$router.push({ name: 'ApkVersionCreate' })
    },
    async baixarApk(version) {
      const value = await http.getDownloadStream(
        `app-version/download/${version.appName}/${version.version}`,
        {},
        (e) => {
          this.progressDownload = e
        }
      )

      fileDownload(value.data, `${version.appName}-${version.version}.apk`)

      this.progressDownload = null
    },
  },
}
</script>
